import React, { Component } from 'react';

import './styles.css';

import ativarnotificacoes from "../../assets/instructions/ligandoanoti.jpg";
import telainicialmicrofone from "../../assets/instructions/telainicial-microfone.png";
import microfonestart from "../../assets/instructions/microfone-start.png";
import microfonestop from "../../assets/instructions/microfone-started.png";
import musicastelainicial from "../../assets/instructions/musicas-telainicial.png";
import musicstart from "../../assets/instructions/music-start.png";
import musicstarting from "../../assets/instructions/music-starting.png";
import musichasstarted from "../../assets/instructions/music-hasstarted.png";
export default class InstructionsPage extends Component {
    render() {
        return(
            <div className="view">
                <h1 className="titleFTM">Instruções para usar o protótipo do FTM</h1>

                {/* <p>Por enquanto infelizmente o site só funciona em dispositivos Android, mas caso você tenha iPhone teste aí e nos mande dizendo se funcionou ou não</p> */}

                <li className="step-by-step">
                    <li>
                        <p className="title">1. Ative as notificações do celular</p>
                        {/* Imagem */}
                        <img className="images" src={ativarnotificacoes} alt="Ative as notificacoes" />
                        <li className="description">Em muitos dispositivos o site não funciona se você não estiver com as notificações ativadas, então para evitar esse erro, ligue as notificações e continue lendo as instruções.</li>
                    </li>
                    <li>
                        <p className="title">2. Teste o microfone</p>
                        {/* Imagem */}
                        <img className="images" src={telainicialmicrofone} alt="Ative as notificacoes" />
                        <li className="description">Clique no botão "microfone".</li>
                    </li>
                    <li>
                        <p className="title">3. Ligue o microfone</p>
                        {/* Imagem */}
                        <img className="images" src={microfonestart} alt="Ative as notificacoes" />
                        <li className="description">Clique onde a seta está apontando e faça um teste fazendo barulho perto do microfone para ver se as vibrações estão funcionando normalmente.</li>
                    </li>
                    <li>
                        <p className="title">4. Microfone rolando</p>
                        {/* Imagem */}
                        <img className="images" src={microfonestop} alt="Ative as notificacoes" />
                        <li className="description">Após testar o microfone e ver que as vibrações estão funcionando, clique onde a seta está apontando para cancelar o microfone e depois pode voltar à tela inicial.</li>
                    </li>
                    <li>
                        <p className="title">5. Clique em "músicas"</p>
                        {/* Imagem */}
                        <img className="images" src={musicastelainicial} alt="Ative as notificacoes" />
                        <li className="description">Após testar o microfone e ver que as vibrações estão funcionando, clique onde a seta está apontando para cancelar o microfone e depois pode voltar à tela inicial.</li>
                    </li>
                    <li>
                        <p className="title">6. Escolha alguma das músicas (a mais legal é a GummyBearz)</p>
                        {/* Imagem */}
                        <img className="images" src={musicstart} alt="Ative as notificacoes" />
                        <li className="description">Escolha alguma das músicas.</li>
                    </li>
                    <li>
                        <p className="title">7. Clique nessas três (3) barrinhas</p>
                        {/* Imagem */}
                        <img className="images" src={musicstarting} alt="Ative as notificacoes" />
                        <li className="description">Após clicar ali a música vai começar a tocar e o seu celular começará a vibrar.</li>
                    </li>
                    <li>
                        <p className="title">8. Você saberá que a música começou quando as três (3) barrinhas ficarem assim</p>
                        {/* Imagem */}
                        <img className="images" src={musichasstarted} alt="Ative as notificacoes" />
                        <li className="description">Após clicar ali a música vai começar a tocar e o seu celular começará a vibrar.</li>
                    </li>
                    <li>
                        <p className="title">9. Para parar a música e a vibração basta recarregar a página</p>
                        {/* Imagem */}
                        <img className="images" src={musichasstarted} alt="Ative as notificacoes" />
                        <li className="description">Recarregando a página você para a música e a vibração. Obrigado por testar! deixe seu comentário (feedback) aqui</li>
                    </li>
                    <textarea
                    placeholder="Faça um comentário"
                    />
                </li>
            </div>
        );
    }
} 

